// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/model_path.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/model_path.proto.
 */
export const file_proto_model_core_model_path = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message carmen.ModelPath.
 * Use `create(ModelPathSchema)` to create a new message.
 */
export const ModelPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 0);

/**
 * Describes the message carmen.UserPath.
 * Use `create(UserPathSchema)` to create a new message.
 */
export const UserPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 1);

/**
 * Describes the message carmen.TripPath.
 * Use `create(TripPathSchema)` to create a new message.
 */
export const TripPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 2);

/**
 * Describes the message carmen.DestinationPath.
 * Use `create(DestinationPathSchema)` to create a new message.
 */
export const DestinationPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 3);

/**
 * Describes the message carmen.ThreadPath.
 * Use `create(ThreadPathSchema)` to create a new message.
 */
export const ThreadPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 4);

/**
 * Describes the message carmen.MessagePath.
 * Use `create(MessagePathSchema)` to create a new message.
 */
export const MessagePathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 5);

/**
 * Describes the message carmen.SchedulePath.
 * Use `create(SchedulePathSchema)` to create a new message.
 */
export const SchedulePathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 6);

/**
 * Describes the message carmen.StayPath.
 * Use `create(StayPathSchema)` to create a new message.
 */
export const StayPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 7);

/**
 * Describes the message carmen.DayPath.
 * Use `create(DayPathSchema)` to create a new message.
 */
export const DayPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 8);

/**
 * Describes the message carmen.EventPath.
 * Use `create(EventPathSchema)` to create a new message.
 */
export const EventPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 9);

/**
 * Describes the message carmen.SearchSessionPath.
 * Use `create(SearchSessionPathSchema)` to create a new message.
 */
export const SearchSessionPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 10);

/**
 * Describes the message carmen.SearchResultPath.
 * Use `create(SearchResultPathSchema)` to create a new message.
 */
export const SearchResultPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 11);

/**
 * Describes the message carmen.TravelerPath.
 * Use `create(TravelerPathSchema)` to create a new message.
 */
export const TravelerPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 12);

/**
 * Describes the message carmen.PaymentPath.
 * Use `create(PaymentPathSchema)` to create a new message.
 */
export const PaymentPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 13);

/**
 * Describes the message carmen.PaymentMethodPath.
 * Use `create(PaymentMethodPathSchema)` to create a new message.
 */
export const PaymentMethodPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 14);

/**
 * Describes the message carmen.BookingPath.
 * Use `create(BookingPathSchema)` to create a new message.
 */
export const BookingPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 15);

/**
 * Describes the message carmen.BookingCartPath.
 * Use `create(BookingCartPathSchema)` to create a new message.
 */
export const BookingCartPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 16);

/**
 * Describes the message carmen.HoldPath.
 * Use `create(HoldPathSchema)` to create a new message.
 */
export const HoldPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 17);

/**
 * Describes the message carmen.CandidatePoolPath.
 * Use `create(CandidatePoolPathSchema)` to create a new message.
 */
export const CandidatePoolPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 18);

/**
 * Describes the message carmen.CandidatePath.
 * Use `create(CandidatePathSchema)` to create a new message.
 */
export const CandidatePathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 19);

/**
 * Describes the message carmen.BudgetPath.
 * Use `create(BudgetPathSchema)` to create a new message.
 */
export const BudgetPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 20);

/**
 * Describes the message carmen.TaxCalculationPath.
 * Use `create(TaxCalculationPathSchema)` to create a new message.
 */
export const TaxCalculationPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 21);

/**
 * Describes the message carmen.TaxRatePath.
 * Use `create(TaxRatePathSchema)` to create a new message.
 */
export const TaxRatePathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 22);

/**
 * Describes the message carmen.TaxExemptionPath.
 * Use `create(TaxExemptionPathSchema)` to create a new message.
 */
export const TaxExemptionPathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 23);

/**
 * Describes the message carmen.TaxCompliancePath.
 * Use `create(TaxCompliancePathSchema)` to create a new message.
 */
export const TaxCompliancePathSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_model_path, 24);

